import React from "react";
import { useSelector } from "react-redux";
import * as actionsFeriado from "../../../store/modules/feriados/actions";
import * as controller from "../../../controllers/feriadosController";
import { Card, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Select } from "../../../components/Inputs/Input";

const Register = () => {
  const { item, nacional, seeRegister,copy } = useSelector(
    (state) => state.feriado
  );

  function handleKeyPress(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      if (!item.id) {
        controller.createFeriado(item);
      } else {
        controller.updateFeriado(item, copy);
      }
    }
  }

  function onChange(field, value) {
    const finalValue = field === "nacional" 
      ? value === null ? null : Boolean(value)
      : value;

    actionsFeriado.setItem({ 
      ...item, 
      [field]: finalValue 
    });
  }

  return (
    <>
      <Col>
        <Card className="radius pb-5">
          <Col className="pt-2">
            <p style={{ fontSize: "20px" }}>
              {item.id ? "Editar Feriado" : "Cadastrar Feriado"}
            </p>
            <p>* Campos obrigatórios</p>
          </Col>
          <Col md={12} className="pt-2">
            <Form>
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label>
                      Nome Do Feriado: <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      type="text"
                      placeholder="Digite aqui..."
                      value={item.descricao || ""}
                      onChange={(e) => onChange("descricao", e.target.value)}
                      onKeyPress={(e) => handleKeyPress(e)}
                      disabled={seeRegister}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>
                      Data: <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      type="date"
                      placeholder="Digite aqui..."
                      value={item.data || ""}
                      onChange={(e) => onChange("data", e.target.value)}
                      onKeyPress={(e) => handleKeyPress(e)}
                      disabled={seeRegister}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>
                      Nacional: <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Select
                      first="SELECIONE"
                      options={nacional}
                      value={nacional.find((opt) => opt.value === item.nacional)}
                      onChange={(e) => onChange("nacional", e.value)}
                      isDisabled={seeRegister}
                      isSearchable={false}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "35px",
                          height: "35px",
                          borderColor: item.invalid?.nacional
                            ? "red"
                            : base.borderColor,
                        }),
                      }}
                    />
                    {item.invalid?.nacional && (
                      <span style={{ color: "red", fontSize: "0.8rem" }}>
                        Campo obrigatório
                      </span>
                    )}
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </Col>
        </Card>
      </Col>
    </>
  );
};

export default Register;